var cov_1uc4i0bxrm = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Datum/Tree.ts",
      hash = "c603240f910fb05ba28b58f033e876d22e204037",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Datum/Tree.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 29
        },
        end: {
          line: 4,
          column: 51
        }
      },
      "1": {
        start: {
          line: 6,
          column: 27
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "2": {
        start: {
          line: 26,
          column: 25
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "3": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 55
        }
      },
      "4": {
        start: {
          line: 27,
          column: 35
        },
        end: {
          line: 27,
          column: 55
        }
      },
      "5": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 66
        }
      },
      "6": {
        start: {
          line: 28,
          column: 24
        },
        end: {
          line: 28,
          column: 31
        }
      },
      "7": {
        start: {
          line: 28,
          column: 58
        },
        end: {
          line: 28,
          column: 66
        }
      },
      "8": {
        start: {
          line: 30,
          column: 12
        },
        end: {
          line: 30,
          column: 49
        }
      },
      "9": {
        start: {
          line: 30,
          column: 30
        },
        end: {
          line: 30,
          column: 48
        }
      },
      "10": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 41
        }
      },
      "11": {
        start: {
          line: 32,
          column: 21
        },
        end: {
          line: 32,
          column: 41
        }
      },
      "12": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 10
        }
      },
      "13": {
        start: {
          line: 92,
          column: 87
        },
        end: {
          line: 92,
          column: 94
        }
      },
      "14": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 24
        }
      },
      "15": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 20
        }
      },
      "16": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 29
        }
      },
      "17": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 38
        }
      },
      "18": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 26
        }
      },
      "19": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 27
        }
      },
      "20": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 21
        }
      },
      "21": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 34
        }
      },
      "22": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 33
        }
      },
      "23": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 24
        }
      },
      "24": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 22
        }
      },
      "25": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "26": {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 110,
          column: 25
        }
      },
      "27": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 33
        }
      },
      "28": {
        start: {
          line: 112,
          column: 28
        },
        end: {
          line: 112,
          column: 33
        }
      },
      "29": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 31
        }
      },
      "30": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 26
        }
      },
      "31": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 38
        }
      },
      "32": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 41
        }
      },
      "33": {
        start: {
          line: 126,
          column: 35
        },
        end: {
          line: 126,
          column: 41
        }
      },
      "34": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 132,
          column: 6
        }
      },
      "35": {
        start: {
          line: 128,
          column: 19
        },
        end: {
          line: 128,
          column: 38
        }
      },
      "36": {
        start: {
          line: 129,
          column: 24
        },
        end: {
          line: 129,
          column: 44
        }
      },
      "37": {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 131,
          column: 43
        }
      },
      "38": {
        start: {
          line: 130,
          column: 21
        },
        end: {
          line: 130,
          column: 56
        }
      },
      "39": {
        start: {
          line: 131,
          column: 11
        },
        end: {
          line: 131,
          column: 43
        }
      },
      "40": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 137,
          column: 45
        }
      },
      "41": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 22
        }
      },
      "42": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 144,
          column: 5
        }
      },
      "43": {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 22
        }
      },
      "44": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 145,
          column: 26
        }
      },
      "45": {
        start: {
          line: 149,
          column: 34
        },
        end: {
          line: 149,
          column: 36
        }
      },
      "46": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 180,
          column: 6
        }
      },
      "47": {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 179,
          column: 7
        }
      },
      "48": {
        start: {
          line: 154,
          column: 10
        },
        end: {
          line: 154,
          column: 43
        }
      },
      "49": {
        start: {
          line: 154,
          column: 29
        },
        end: {
          line: 154,
          column: 43
        }
      },
      "50": {
        start: {
          line: 155,
          column: 10
        },
        end: {
          line: 155,
          column: 15
        }
      },
      "51": {
        start: {
          line: 157,
          column: 10
        },
        end: {
          line: 157,
          column: 42
        }
      },
      "52": {
        start: {
          line: 157,
          column: 28
        },
        end: {
          line: 157,
          column: 42
        }
      },
      "53": {
        start: {
          line: 158,
          column: 10
        },
        end: {
          line: 158,
          column: 15
        }
      },
      "54": {
        start: {
          line: 160,
          column: 10
        },
        end: {
          line: 163,
          column: 11
        }
      },
      "55": {
        start: {
          line: 161,
          column: 25
        },
        end: {
          line: 161,
          column: 45
        }
      },
      "56": {
        start: {
          line: 162,
          column: 12
        },
        end: {
          line: 162,
          column: 66
        }
      },
      "57": {
        start: {
          line: 162,
          column: 52
        },
        end: {
          line: 162,
          column: 66
        }
      },
      "58": {
        start: {
          line: 164,
          column: 10
        },
        end: {
          line: 164,
          column: 15
        }
      },
      "59": {
        start: {
          line: 166,
          column: 10
        },
        end: {
          line: 176,
          column: 11
        }
      },
      "60": {
        start: {
          line: 167,
          column: 34
        },
        end: {
          line: 174,
          column: 16
        }
      },
      "61": {
        start: {
          line: 168,
          column: 27
        },
        end: {
          line: 168,
          column: 47
        }
      },
      "62": {
        start: {
          line: 169,
          column: 14
        },
        end: {
          line: 169,
          column: 37
        }
      },
      "63": {
        start: {
          line: 169,
          column: 25
        },
        end: {
          line: 169,
          column: 37
        }
      },
      "64": {
        start: {
          line: 170,
          column: 31
        },
        end: {
          line: 170,
          column: 35
        }
      },
      "65": {
        start: {
          line: 171,
          column: 26
        },
        end: {
          line: 171,
          column: 47
        }
      },
      "66": {
        start: {
          line: 172,
          column: 14
        },
        end: {
          line: 172,
          column: 49
        }
      },
      "67": {
        start: {
          line: 172,
          column: 37
        },
        end: {
          line: 172,
          column: 49
        }
      },
      "68": {
        start: {
          line: 173,
          column: 14
        },
        end: {
          line: 173,
          column: 49
        }
      },
      "69": {
        start: {
          line: 175,
          column: 12
        },
        end: {
          line: 175,
          column: 46
        }
      },
      "70": {
        start: {
          line: 175,
          column: 32
        },
        end: {
          line: 175,
          column: 46
        }
      },
      "71": {
        start: {
          line: 177,
          column: 10
        },
        end: {
          line: 177,
          column: 15
        }
      },
      "72": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 183,
          column: 6
        }
      },
      "73": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 49
        }
      },
      "74": {
        start: {
          line: 182,
          column: 35
        },
        end: {
          line: 182,
          column: 49
        }
      },
      "75": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 184,
          column: 28
        }
      },
      "76": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 185,
          column: 25
        }
      },
      "77": {
        start: {
          line: 189,
          column: 4
        },
        end: {
          line: 189,
          column: 34
        }
      },
      "78": {
        start: {
          line: 190,
          column: 19
        },
        end: {
          line: 190,
          column: 38
        }
      },
      "79": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 191,
          column: 24
        }
      },
      "80": {
        start: {
          line: 191,
          column: 16
        },
        end: {
          line: 191,
          column: 24
        }
      },
      "81": {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 196,
          column: 59
        }
      },
      "82": {
        start: {
          line: 196,
          column: 30
        },
        end: {
          line: 196,
          column: 59
        }
      },
      "83": {
        start: {
          line: 198,
          column: 17
        },
        end: {
          line: 198,
          column: 37
        }
      },
      "84": {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 204,
          column: 5
        }
      },
      "85": {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 202,
          column: 44
        }
      },
      "86": {
        start: {
          line: 201,
          column: 19
        },
        end: {
          line: 201,
          column: 55
        }
      },
      "87": {
        start: {
          line: 202,
          column: 11
        },
        end: {
          line: 202,
          column: 44
        }
      },
      "88": {
        start: {
          line: 203,
          column: 6
        },
        end: {
          line: 203,
          column: 17
        }
      },
      "89": {
        start: {
          line: 206,
          column: 4
        },
        end: {
          line: 209,
          column: 5
        }
      },
      "90": {
        start: {
          line: 208,
          column: 6
        },
        end: {
          line: 208,
          column: 14
        }
      },
      "91": {
        start: {
          line: 211,
          column: 31
        },
        end: {
          line: 211,
          column: 52
        }
      },
      "92": {
        start: {
          line: 213,
          column: 31
        },
        end: {
          line: 213,
          column: 33
        }
      },
      "93": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 220,
          column: 5
        }
      },
      "94": {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 219,
          column: 8
        }
      },
      "95": {
        start: {
          line: 218,
          column: 8
        },
        end: {
          line: 218,
          column: 58
        }
      },
      "96": {
        start: {
          line: 223,
          column: 18
        },
        end: {
          line: 223,
          column: 40
        }
      },
      "97": {
        start: {
          line: 226,
          column: 19
        },
        end: {
          line: 226,
          column: 59
        }
      },
      "98": {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 231,
          column: 5
        }
      },
      "99": {
        start: {
          line: 229,
          column: 6
        },
        end: {
          line: 229,
          column: 34
        }
      },
      "100": {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 230,
          column: 22
        }
      },
      "101": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 243,
          column: 5
        }
      },
      "102": {
        start: {
          line: 235,
          column: 23
        },
        end: {
          line: 235,
          column: 44
        }
      },
      "103": {
        start: {
          line: 236,
          column: 26
        },
        end: {
          line: 236,
          column: 33
        }
      },
      "104": {
        start: {
          line: 237,
          column: 6
        },
        end: {
          line: 241,
          column: 8
        }
      },
      "105": {
        start: {
          line: 238,
          column: 8
        },
        end: {
          line: 240,
          column: 9
        }
      },
      "106": {
        start: {
          line: 239,
          column: 10
        },
        end: {
          line: 239,
          column: 27
        }
      },
      "107": {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 242,
          column: 46
        }
      },
      "108": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 244,
          column: 18
        }
      },
      "109": {
        start: {
          line: 248,
          column: 17
        },
        end: {
          line: 248,
          column: 37
        }
      },
      "110": {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 249,
          column: 36
        }
      },
      "111": {
        start: {
          line: 249,
          column: 14
        },
        end: {
          line: 249,
          column: 36
        }
      },
      "112": {
        start: {
          line: 250,
          column: 4
        },
        end: {
          line: 250,
          column: 16
        }
      },
      "113": {
        start: {
          line: 254,
          column: 4
        },
        end: {
          line: 254,
          column: 32
        }
      },
      "114": {
        start: {
          line: 258,
          column: 23
        },
        end: {
          line: 258,
          column: 43
        }
      },
      "115": {
        start: {
          line: 259,
          column: 4
        },
        end: {
          line: 259,
          column: 37
        }
      },
      "116": {
        start: {
          line: 259,
          column: 20
        },
        end: {
          line: 259,
          column: 37
        }
      },
      "117": {
        start: {
          line: 260,
          column: 4
        },
        end: {
          line: 260,
          column: 34
        }
      },
      "118": {
        start: {
          line: 260,
          column: 23
        },
        end: {
          line: 260,
          column: 34
        }
      },
      "119": {
        start: {
          line: 261,
          column: 4
        },
        end: {
          line: 261,
          column: 54
        }
      },
      "120": {
        start: {
          line: 265,
          column: 4
        },
        end: {
          line: 265,
          column: 31
        }
      },
      "121": {
        start: {
          line: 269,
          column: 18
        },
        end: {
          line: 269,
          column: 30
        }
      },
      "122": {
        start: {
          line: 270,
          column: 45
        },
        end: {
          line: 270,
          column: 56
        }
      },
      "123": {
        start: {
          line: 271,
          column: 4
        },
        end: {
          line: 271,
          column: 46
        }
      },
      "124": {
        start: {
          line: 271,
          column: 21
        },
        end: {
          line: 271,
          column: 46
        }
      },
      "125": {
        start: {
          line: 272,
          column: 4
        },
        end: {
          line: 272,
          column: 18
        }
      },
      "126": {
        start: {
          line: 276,
          column: 4
        },
        end: {
          line: 276,
          column: 81
        }
      },
      "127": {
        start: {
          line: 276,
          column: 43
        },
        end: {
          line: 276,
          column: 81
        }
      },
      "128": {
        start: {
          line: 277,
          column: 4
        },
        end: {
          line: 277,
          column: 88
        }
      },
      "129": {
        start: {
          line: 277,
          column: 21
        },
        end: {
          line: 277,
          column: 88
        }
      },
      "130": {
        start: {
          line: 278,
          column: 4
        },
        end: {
          line: 278,
          column: 39
        }
      },
      "131": {
        start: {
          line: 282,
          column: 4
        },
        end: {
          line: 282,
          column: 51
        }
      },
      "132": {
        start: {
          line: 282,
          column: 35
        },
        end: {
          line: 282,
          column: 51
        }
      },
      "133": {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 289,
          column: 5
        }
      },
      "134": {
        start: {
          line: 285,
          column: 6
        },
        end: {
          line: 285,
          column: 14
        }
      },
      "135": {
        start: {
          line: 286,
          column: 6
        },
        end: {
          line: 288,
          column: 8
        }
      },
      "136": {
        start: {
          line: 287,
          column: 8
        },
        end: {
          line: 287,
          column: 48
        }
      },
      "137": {
        start: {
          line: 287,
          column: 35
        },
        end: {
          line: 287,
          column: 48
        }
      },
      "138": {
        start: {
          line: 292,
          column: 4
        },
        end: {
          line: 317,
          column: 6
        }
      },
      "139": {
        start: {
          line: 293,
          column: 27
        },
        end: {
          line: 293,
          column: 48
        }
      },
      "140": {
        start: {
          line: 295,
          column: 6
        },
        end: {
          line: 299,
          column: 7
        }
      },
      "141": {
        start: {
          line: 296,
          column: 8
        },
        end: {
          line: 296,
          column: 31
        }
      },
      "142": {
        start: {
          line: 297,
          column: 8
        },
        end: {
          line: 297,
          column: 44
        }
      },
      "143": {
        start: {
          line: 298,
          column: 8
        },
        end: {
          line: 298,
          column: 14
        }
      },
      "144": {
        start: {
          line: 301,
          column: 40
        },
        end: {
          line: 301,
          column: 76
        }
      },
      "145": {
        start: {
          line: 303,
          column: 6
        },
        end: {
          line: 311,
          column: 7
        }
      },
      "146": {
        start: {
          line: 304,
          column: 8
        },
        end: {
          line: 304,
          column: 38
        }
      },
      "147": {
        start: {
          line: 305,
          column: 13
        },
        end: {
          line: 311,
          column: 7
        }
      },
      "148": {
        start: {
          line: 307,
          column: 35
        },
        end: {
          line: 307,
          column: 60
        }
      },
      "149": {
        start: {
          line: 308,
          column: 8
        },
        end: {
          line: 308,
          column: 77
        }
      },
      "150": {
        start: {
          line: 310,
          column: 8
        },
        end: {
          line: 310,
          column: 59
        }
      },
      "151": {
        start: {
          line: 313,
          column: 6
        },
        end: {
          line: 313,
          column: 40
        }
      },
      "152": {
        start: {
          line: 315,
          column: 6
        },
        end: {
          line: 316,
          column: 52
        }
      },
      "153": {
        start: {
          line: 315,
          column: 33
        },
        end: {
          line: 315,
          column: 55
        }
      },
      "154": {
        start: {
          line: 316,
          column: 11
        },
        end: {
          line: 316,
          column: 52
        }
      },
      "155": {
        start: {
          line: 316,
          column: 41
        },
        end: {
          line: 316,
          column: 52
        }
      },
      "156": {
        start: {
          line: 319,
          column: 4
        },
        end: {
          line: 319,
          column: 19
        }
      },
      "157": {
        start: {
          line: 323,
          column: 32
        },
        end: {
          line: 323,
          column: 34
        }
      },
      "158": {
        start: {
          line: 324,
          column: 4
        },
        end: {
          line: 356,
          column: 6
        }
      },
      "159": {
        start: {
          line: 325,
          column: 17
        },
        end: {
          line: 325,
          column: 57
        }
      },
      "160": {
        start: {
          line: 326,
          column: 6
        },
        end: {
          line: 329,
          column: 7
        }
      },
      "161": {
        start: {
          line: 327,
          column: 8
        },
        end: {
          line: 327,
          column: 87
        }
      },
      "162": {
        start: {
          line: 328,
          column: 8
        },
        end: {
          line: 328,
          column: 14
        }
      },
      "163": {
        start: {
          line: 330,
          column: 6
        },
        end: {
          line: 330,
          column: 29
        }
      },
      "164": {
        start: {
          line: 332,
          column: 23
        },
        end: {
          line: 332,
          column: 33
        }
      },
      "165": {
        start: {
          line: 333,
          column: 6
        },
        end: {
          line: 335,
          column: 7
        }
      },
      "166": {
        start: {
          line: 334,
          column: 8
        },
        end: {
          line: 334,
          column: 40
        }
      },
      "167": {
        start: {
          line: 337,
          column: 24
        },
        end: {
          line: 337,
          column: 37
        }
      },
      "168": {
        start: {
          line: 338,
          column: 6
        },
        end: {
          line: 338,
          column: 18
        }
      },
      "169": {
        start: {
          line: 339,
          column: 37
        },
        end: {
          line: 339,
          column: 39
        }
      },
      "170": {
        start: {
          line: 340,
          column: 6
        },
        end: {
          line: 348,
          column: 7
        }
      },
      "171": {
        start: {
          line: 341,
          column: 8
        },
        end: {
          line: 347,
          column: 9
        }
      },
      "172": {
        start: {
          line: 349,
          column: 6
        },
        end: {
          line: 355,
          column: 8
        }
      },
      "173": {
        start: {
          line: 357,
          column: 4
        },
        end: {
          line: 357,
          column: 14
        }
      },
      "174": {
        start: {
          line: 361,
          column: 29
        },
        end: {
          line: 361,
          column: 45
        }
      },
      "175": {
        start: {
          line: 362,
          column: 4
        },
        end: {
          line: 362,
          column: 25
        }
      },
      "176": {
        start: {
          line: 363,
          column: 4
        },
        end: {
          line: 363,
          column: 28
        }
      },
      "177": {
        start: {
          line: 364,
          column: 4
        },
        end: {
          line: 364,
          column: 28
        }
      },
      "178": {
        start: {
          line: 365,
          column: 4
        },
        end: {
          line: 365,
          column: 29
        }
      },
      "179": {
        start: {
          line: 366,
          column: 4
        },
        end: {
          line: 366,
          column: 38
        }
      },
      "180": {
        start: {
          line: 367,
          column: 4
        },
        end: {
          line: 367,
          column: 20
        }
      },
      "181": {
        start: {
          line: 369,
          column: 4
        },
        end: {
          line: 369,
          column: 21
        }
      },
      "182": {
        start: {
          line: 369,
          column: 15
        },
        end: {
          line: 369,
          column: 21
        }
      },
      "183": {
        start: {
          line: 371,
          column: 4
        },
        end: {
          line: 371,
          column: 27
        }
      },
      "184": {
        start: {
          line: 372,
          column: 4
        },
        end: {
          line: 372,
          column: 20
        }
      },
      "185": {
        start: {
          line: 373,
          column: 4
        },
        end: {
          line: 373,
          column: 37
        }
      },
      "186": {
        start: {
          line: 374,
          column: 4
        },
        end: {
          line: 374,
          column: 45
        }
      },
      "187": {
        start: {
          line: 374,
          column: 18
        },
        end: {
          line: 374,
          column: 45
        }
      },
      "188": {
        start: {
          line: 378,
          column: 4
        },
        end: {
          line: 378,
          column: 52
        }
      },
      "189": {
        start: {
          line: 378,
          column: 29
        },
        end: {
          line: 378,
          column: 52
        }
      },
      "190": {
        start: {
          line: 379,
          column: 19
        },
        end: {
          line: 379,
          column: 37
        }
      },
      "191": {
        start: {
          line: 380,
          column: 4
        },
        end: {
          line: 380,
          column: 35
        }
      },
      "192": {
        start: {
          line: 380,
          column: 29
        },
        end: {
          line: 380,
          column: 35
        }
      },
      "193": {
        start: {
          line: 381,
          column: 4
        },
        end: {
          line: 381,
          column: 19
        }
      },
      "194": {
        start: {
          line: 385,
          column: 4
        },
        end: {
          line: 385,
          column: 35
        }
      },
      "195": {
        start: {
          line: 385,
          column: 29
        },
        end: {
          line: 385,
          column: 35
        }
      },
      "196": {
        start: {
          line: 386,
          column: 4
        },
        end: {
          line: 386,
          column: 65
        }
      },
      "197": {
        start: {
          line: 386,
          column: 56
        },
        end: {
          line: 386,
          column: 64
        }
      },
      "198": {
        start: {
          line: 390,
          column: 18
        },
        end: {
          line: 390,
          column: 36
        }
      },
      "199": {
        start: {
          line: 391,
          column: 4
        },
        end: {
          line: 391,
          column: 22
        }
      },
      "200": {
        start: {
          line: 391,
          column: 16
        },
        end: {
          line: 391,
          column: 22
        }
      },
      "201": {
        start: {
          line: 392,
          column: 4
        },
        end: {
          line: 392,
          column: 36
        }
      },
      "202": {
        start: {
          line: 392,
          column: 24
        },
        end: {
          line: 392,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 25
          },
          end: {
            line: 26,
            column: 26
          }
        },
        loc: {
          start: {
            line: 26,
            column: 83
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 19
          },
          end: {
            line: 28,
            column: 20
          }
        },
        loc: {
          start: {
            line: 28,
            column: 24
          },
          end: {
            line: 28,
            column: 31
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 30,
            column: 25
          },
          end: {
            line: 30,
            column: 26
          }
        },
        loc: {
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 48
          }
        },
        line: 30
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 79
          },
          end: {
            line: 106,
            column: 3
          }
        },
        line: 91
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 108,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        },
        loc: {
          start: {
            line: 108,
            column: 58
          },
          end: {
            line: 114,
            column: 3
          }
        },
        line: 108
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 112,
            column: 22
          },
          end: {
            line: 112,
            column: 23
          }
        },
        loc: {
          start: {
            line: 112,
            column: 28
          },
          end: {
            line: 112,
            column: 33
          }
        },
        line: 112
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 116,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        },
        loc: {
          start: {
            line: 116,
            column: 46
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 116
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 120,
            column: 2
          },
          end: {
            line: 120,
            column: 3
          }
        },
        loc: {
          start: {
            line: 120,
            column: 27
          },
          end: {
            line: 122,
            column: 3
          }
        },
        line: 120
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 3
          }
        },
        loc: {
          start: {
            line: 124,
            column: 20
          },
          end: {
            line: 133,
            column: 3
          }
        },
        line: 124
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 127,
            column: 23
          },
          end: {
            line: 127,
            column: 24
          }
        },
        loc: {
          start: {
            line: 127,
            column: 28
          },
          end: {
            line: 132,
            column: 5
          }
        },
        line: 127
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 136,
            column: 3
          }
        },
        loc: {
          start: {
            line: 136,
            column: 61
          },
          end: {
            line: 138,
            column: 3
          }
        },
        line: 136
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 140,
            column: 2
          },
          end: {
            line: 140,
            column: 3
          }
        },
        loc: {
          start: {
            line: 140,
            column: 26
          },
          end: {
            line: 146,
            column: 3
          }
        },
        line: 140
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 148,
            column: 2
          },
          end: {
            line: 148,
            column: 3
          }
        },
        loc: {
          start: {
            line: 148,
            column: 13
          },
          end: {
            line: 186,
            column: 3
          }
        },
        line: 148
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 150,
            column: 26
          },
          end: {
            line: 150,
            column: 27
          }
        },
        loc: {
          start: {
            line: 150,
            column: 43
          },
          end: {
            line: 180,
            column: 5
          }
        },
        line: 150
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 167,
            column: 35
          },
          end: {
            line: 167,
            column: 36
          }
        },
        loc: {
          start: {
            line: 167,
            column: 41
          },
          end: {
            line: 174,
            column: 13
          }
        },
        line: 167
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 181,
            column: 35
          },
          end: {
            line: 181,
            column: 36
          }
        },
        loc: {
          start: {
            line: 181,
            column: 52
          },
          end: {
            line: 183,
            column: 5
          }
        },
        line: 181
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 188,
            column: 2
          },
          end: {
            line: 188,
            column: 3
          }
        },
        loc: {
          start: {
            line: 188,
            column: 56
          },
          end: {
            line: 192,
            column: 3
          }
        },
        line: 188
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 194,
            column: 2
          },
          end: {
            line: 194,
            column: 3
          }
        },
        loc: {
          start: {
            line: 194,
            column: 76
          },
          end: {
            line: 245,
            column: 3
          }
        },
        line: 194
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 216,
            column: 23
          },
          end: {
            line: 216,
            column: 24
          }
        },
        loc: {
          start: {
            line: 216,
            column: 30
          },
          end: {
            line: 219,
            column: 7
          }
        },
        line: 216
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 237,
            column: 51
          },
          end: {
            line: 237,
            column: 52
          }
        },
        loc: {
          start: {
            line: 237,
            column: 58
          },
          end: {
            line: 241,
            column: 7
          }
        },
        line: 237
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 247,
            column: 2
          },
          end: {
            line: 247,
            column: 3
          }
        },
        loc: {
          start: {
            line: 247,
            column: 31
          },
          end: {
            line: 251,
            column: 3
          }
        },
        line: 247
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 253,
            column: 2
          },
          end: {
            line: 253,
            column: 3
          }
        },
        loc: {
          start: {
            line: 253,
            column: 24
          },
          end: {
            line: 255,
            column: 3
          }
        },
        line: 253
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 257,
            column: 2
          },
          end: {
            line: 257,
            column: 3
          }
        },
        loc: {
          start: {
            line: 257,
            column: 32
          },
          end: {
            line: 262,
            column: 3
          }
        },
        line: 257
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 264,
            column: 2
          },
          end: {
            line: 264,
            column: 3
          }
        },
        loc: {
          start: {
            line: 264,
            column: 28
          },
          end: {
            line: 266,
            column: 3
          }
        },
        line: 264
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 268,
            column: 2
          },
          end: {
            line: 268,
            column: 3
          }
        },
        loc: {
          start: {
            line: 268,
            column: 31
          },
          end: {
            line: 273,
            column: 3
          }
        },
        line: 268
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 275,
            column: 2
          },
          end: {
            line: 275,
            column: 3
          }
        },
        loc: {
          start: {
            line: 275,
            column: 74
          },
          end: {
            line: 279,
            column: 3
          }
        },
        line: 275
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 281,
            column: 2
          },
          end: {
            line: 281,
            column: 3
          }
        },
        loc: {
          start: {
            line: 281,
            column: 56
          },
          end: {
            line: 320,
            column: 3
          }
        },
        line: 281
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 286,
            column: 27
          },
          end: {
            line: 286,
            column: 28
          }
        },
        loc: {
          start: {
            line: 286,
            column: 40
          },
          end: {
            line: 288,
            column: 7
          }
        },
        line: 286
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 292,
            column: 16
          },
          end: {
            line: 292,
            column: 17
          }
        },
        loc: {
          start: {
            line: 292,
            column: 22
          },
          end: {
            line: 317,
            column: 5
          }
        },
        line: 292
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 322,
            column: 2
          },
          end: {
            line: 322,
            column: 3
          }
        },
        loc: {
          start: {
            line: 322,
            column: 89
          },
          end: {
            line: 358,
            column: 3
          }
        },
        line: 322
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 324,
            column: 17
          },
          end: {
            line: 324,
            column: 18
          }
        },
        loc: {
          start: {
            line: 324,
            column: 27
          },
          end: {
            line: 356,
            column: 5
          }
        },
        line: 324
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 360,
            column: 2
          },
          end: {
            line: 360,
            column: 3
          }
        },
        loc: {
          start: {
            line: 360,
            column: 45
          },
          end: {
            line: 375,
            column: 3
          }
        },
        line: 360
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 377,
            column: 2
          },
          end: {
            line: 377,
            column: 3
          }
        },
        loc: {
          start: {
            line: 377,
            column: 40
          },
          end: {
            line: 382,
            column: 3
          }
        },
        line: 377
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 384,
            column: 2
          },
          end: {
            line: 384,
            column: 3
          }
        },
        loc: {
          start: {
            line: 384,
            column: 42
          },
          end: {
            line: 387,
            column: 3
          }
        },
        line: 384
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 386,
            column: 51
          },
          end: {
            line: 386,
            column: 52
          }
        },
        loc: {
          start: {
            line: 386,
            column: 56
          },
          end: {
            line: 386,
            column: 64
          }
        },
        line: 386
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 389,
            column: 2
          },
          end: {
            line: 389,
            column: 3
          }
        },
        loc: {
          start: {
            line: 389,
            column: 39
          },
          end: {
            line: 393,
            column: 3
          }
        },
        line: 389
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 392,
            column: 18
          },
          end: {
            line: 392,
            column: 19
          }
        },
        loc: {
          start: {
            line: 392,
            column: 24
          },
          end: {
            line: 392,
            column: 35
          }
        },
        line: 392
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 55
          }
        }, {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 55
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 12
          }
        }, {
          start: {
            line: 27,
            column: 16
          },
          end: {
            line: 27,
            column: 33
          }
        }],
        line: 27
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 66
          }
        }, {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 66
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 37
          }
        }, {
          start: {
            line: 30,
            column: 41
          },
          end: {
            line: 30,
            column: 48
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 41
          }
        }, {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 41
          }
        }],
        line: 32
      },
      "5": {
        loc: {
          start: {
            line: 91,
            column: 14
          },
          end: {
            line: 91,
            column: 77
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 91,
            column: 48
          },
          end: {
            line: 91,
            column: 77
          }
        }],
        line: 91
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 49
          },
          end: {
            line: 92,
            column: 73
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 92,
            column: 63
          },
          end: {
            line: 92,
            column: 73
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }, {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }],
        line: 109
      },
      "8": {
        loc: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 41
          }
        }, {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 41
          }
        }],
        line: 126
      },
      "9": {
        loc: {
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 19
          }
        }, {
          start: {
            line: 126,
            column: 23
          },
          end: {
            line: 126,
            column: 33
          }
        }],
        line: 126
      },
      "10": {
        loc: {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 131,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 131,
            column: 43
          }
        }, {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 131,
            column: 43
          }
        }],
        line: 130
      },
      "11": {
        loc: {
          start: {
            line: 137,
            column: 11
          },
          end: {
            line: 137,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 11
          },
          end: {
            line: 137,
            column: 15
          }
        }, {
          start: {
            line: 137,
            column: 19
          },
          end: {
            line: 137,
            column: 45
          }
        }],
        line: 137
      },
      "12": {
        loc: {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        }, {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        }],
        line: 142
      },
      "13": {
        loc: {
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 142,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 142,
            column: 13
          }
        }, {
          start: {
            line: 142,
            column: 17
          },
          end: {
            line: 142,
            column: 43
          }
        }],
        line: 142
      },
      "14": {
        loc: {
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 179,
            column: 7
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 152,
            column: 30
          }
        }, {
          start: {
            line: 153,
            column: 8
          },
          end: {
            line: 155,
            column: 15
          }
        }, {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 158,
            column: 15
          }
        }, {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 164,
            column: 15
          }
        }, {
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 177,
            column: 15
          }
        }, {
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 178,
            column: 16
          }
        }],
        line: 151
      },
      "15": {
        loc: {
          start: {
            line: 154,
            column: 10
          },
          end: {
            line: 154,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 10
          },
          end: {
            line: 154,
            column: 43
          }
        }, {
          start: {
            line: 154,
            column: 10
          },
          end: {
            line: 154,
            column: 43
          }
        }],
        line: 154
      },
      "16": {
        loc: {
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 157,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 157,
            column: 42
          }
        }, {
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 157,
            column: 42
          }
        }],
        line: 157
      },
      "17": {
        loc: {
          start: {
            line: 160,
            column: 10
          },
          end: {
            line: 163,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 160,
            column: 10
          },
          end: {
            line: 163,
            column: 11
          }
        }, {
          start: {
            line: 160,
            column: 10
          },
          end: {
            line: 163,
            column: 11
          }
        }],
        line: 160
      },
      "18": {
        loc: {
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 162,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 162,
            column: 66
          }
        }, {
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 162,
            column: 66
          }
        }],
        line: 162
      },
      "19": {
        loc: {
          start: {
            line: 162,
            column: 16
          },
          end: {
            line: 162,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 16
          },
          end: {
            line: 162,
            column: 20
          }
        }, {
          start: {
            line: 162,
            column: 24
          },
          end: {
            line: 162,
            column: 50
          }
        }],
        line: 162
      },
      "20": {
        loc: {
          start: {
            line: 166,
            column: 10
          },
          end: {
            line: 176,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 10
          },
          end: {
            line: 176,
            column: 11
          }
        }, {
          start: {
            line: 166,
            column: 10
          },
          end: {
            line: 176,
            column: 11
          }
        }],
        line: 166
      },
      "21": {
        loc: {
          start: {
            line: 169,
            column: 14
          },
          end: {
            line: 169,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 169,
            column: 14
          },
          end: {
            line: 169,
            column: 37
          }
        }, {
          start: {
            line: 169,
            column: 14
          },
          end: {
            line: 169,
            column: 37
          }
        }],
        line: 169
      },
      "22": {
        loc: {
          start: {
            line: 172,
            column: 14
          },
          end: {
            line: 172,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 14
          },
          end: {
            line: 172,
            column: 49
          }
        }, {
          start: {
            line: 172,
            column: 14
          },
          end: {
            line: 172,
            column: 49
          }
        }],
        line: 172
      },
      "23": {
        loc: {
          start: {
            line: 172,
            column: 18
          },
          end: {
            line: 172,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 172,
            column: 18
          },
          end: {
            line: 172,
            column: 22
          }
        }, {
          start: {
            line: 172,
            column: 26
          },
          end: {
            line: 172,
            column: 35
          }
        }],
        line: 172
      },
      "24": {
        loc: {
          start: {
            line: 175,
            column: 12
          },
          end: {
            line: 175,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 12
          },
          end: {
            line: 175,
            column: 46
          }
        }, {
          start: {
            line: 175,
            column: 12
          },
          end: {
            line: 175,
            column: 46
          }
        }],
        line: 175
      },
      "25": {
        loc: {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 49
          }
        }, {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 49
          }
        }],
        line: 182
      },
      "26": {
        loc: {
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 182,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 182,
            column: 17
          }
        }, {
          start: {
            line: 182,
            column: 21
          },
          end: {
            line: 182,
            column: 33
          }
        }],
        line: 182
      },
      "27": {
        loc: {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 24
          }
        }, {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 24
          }
        }],
        line: 191
      },
      "28": {
        loc: {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 196,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 196,
            column: 59
          }
        }, {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 196,
            column: 59
          }
        }],
        line: 196
      },
      "29": {
        loc: {
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 204,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 204,
            column: 5
          }
        }, {
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 204,
            column: 5
          }
        }],
        line: 200
      },
      "30": {
        loc: {
          start: {
            line: 200,
            column: 8
          },
          end: {
            line: 200,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 200,
            column: 8
          },
          end: {
            line: 200,
            column: 12
          }
        }, {
          start: {
            line: 200,
            column: 16
          },
          end: {
            line: 200,
            column: 58
          }
        }],
        line: 200
      },
      "31": {
        loc: {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 202,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 202,
            column: 44
          }
        }, {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 202,
            column: 44
          }
        }],
        line: 201
      },
      "32": {
        loc: {
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 209,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 209,
            column: 5
          }
        }, {
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 209,
            column: 5
          }
        }],
        line: 206
      },
      "33": {
        loc: {
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        }, {
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        }],
        line: 215
      },
      "34": {
        loc: {
          start: {
            line: 228,
            column: 4
          },
          end: {
            line: 231,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 228,
            column: 4
          },
          end: {
            line: 231,
            column: 5
          }
        }, {
          start: {
            line: 228,
            column: 4
          },
          end: {
            line: 231,
            column: 5
          }
        }],
        line: 228
      },
      "35": {
        loc: {
          start: {
            line: 234,
            column: 4
          },
          end: {
            line: 243,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 234,
            column: 4
          },
          end: {
            line: 243,
            column: 5
          }
        }, {
          start: {
            line: 234,
            column: 4
          },
          end: {
            line: 243,
            column: 5
          }
        }],
        line: 234
      },
      "36": {
        loc: {
          start: {
            line: 234,
            column: 8
          },
          end: {
            line: 234,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 234,
            column: 8
          },
          end: {
            line: 234,
            column: 28
          }
        }, {
          start: {
            line: 234,
            column: 32
          },
          end: {
            line: 234,
            column: 47
          }
        }],
        line: 234
      },
      "37": {
        loc: {
          start: {
            line: 238,
            column: 8
          },
          end: {
            line: 240,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 238,
            column: 8
          },
          end: {
            line: 240,
            column: 9
          }
        }, {
          start: {
            line: 238,
            column: 8
          },
          end: {
            line: 240,
            column: 9
          }
        }],
        line: 238
      },
      "38": {
        loc: {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 249,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 249,
            column: 36
          }
        }, {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 249,
            column: 36
          }
        }],
        line: 249
      },
      "39": {
        loc: {
          start: {
            line: 259,
            column: 4
          },
          end: {
            line: 259,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 259,
            column: 4
          },
          end: {
            line: 259,
            column: 37
          }
        }, {
          start: {
            line: 259,
            column: 4
          },
          end: {
            line: 259,
            column: 37
          }
        }],
        line: 259
      },
      "40": {
        loc: {
          start: {
            line: 260,
            column: 4
          },
          end: {
            line: 260,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 260,
            column: 4
          },
          end: {
            line: 260,
            column: 34
          }
        }, {
          start: {
            line: 260,
            column: 4
          },
          end: {
            line: 260,
            column: 34
          }
        }],
        line: 260
      },
      "41": {
        loc: {
          start: {
            line: 271,
            column: 4
          },
          end: {
            line: 271,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 271,
            column: 4
          },
          end: {
            line: 271,
            column: 46
          }
        }, {
          start: {
            line: 271,
            column: 4
          },
          end: {
            line: 271,
            column: 46
          }
        }],
        line: 271
      },
      "42": {
        loc: {
          start: {
            line: 275,
            column: 21
          },
          end: {
            line: 275,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 275,
            column: 40
          },
          end: {
            line: 275,
            column: 42
          }
        }],
        line: 275
      },
      "43": {
        loc: {
          start: {
            line: 276,
            column: 4
          },
          end: {
            line: 276,
            column: 81
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 276,
            column: 4
          },
          end: {
            line: 276,
            column: 81
          }
        }, {
          start: {
            line: 276,
            column: 4
          },
          end: {
            line: 276,
            column: 81
          }
        }],
        line: 276
      },
      "44": {
        loc: {
          start: {
            line: 277,
            column: 4
          },
          end: {
            line: 277,
            column: 88
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 277,
            column: 4
          },
          end: {
            line: 277,
            column: 88
          }
        }, {
          start: {
            line: 277,
            column: 4
          },
          end: {
            line: 277,
            column: 88
          }
        }],
        line: 277
      },
      "45": {
        loc: {
          start: {
            line: 278,
            column: 17
          },
          end: {
            line: 278,
            column: 30
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 278,
            column: 22
          },
          end: {
            line: 278,
            column: 25
          }
        }, {
          start: {
            line: 278,
            column: 28
          },
          end: {
            line: 278,
            column: 30
          }
        }],
        line: 278
      },
      "46": {
        loc: {
          start: {
            line: 282,
            column: 4
          },
          end: {
            line: 282,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 282,
            column: 4
          },
          end: {
            line: 282,
            column: 51
          }
        }, {
          start: {
            line: 282,
            column: 4
          },
          end: {
            line: 282,
            column: 51
          }
        }],
        line: 282
      },
      "47": {
        loc: {
          start: {
            line: 282,
            column: 8
          },
          end: {
            line: 282,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 282,
            column: 8
          },
          end: {
            line: 282,
            column: 18
          }
        }, {
          start: {
            line: 282,
            column: 22
          },
          end: {
            line: 282,
            column: 33
          }
        }],
        line: 282
      },
      "48": {
        loc: {
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 289,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 289,
            column: 5
          }
        }, {
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 289,
            column: 5
          }
        }],
        line: 284
      },
      "49": {
        loc: {
          start: {
            line: 287,
            column: 8
          },
          end: {
            line: 287,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 287,
            column: 8
          },
          end: {
            line: 287,
            column: 48
          }
        }, {
          start: {
            line: 287,
            column: 8
          },
          end: {
            line: 287,
            column: 48
          }
        }],
        line: 287
      },
      "50": {
        loc: {
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 299,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 299,
            column: 7
          }
        }, {
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 299,
            column: 7
          }
        }],
        line: 295
      },
      "51": {
        loc: {
          start: {
            line: 301,
            column: 40
          },
          end: {
            line: 301,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 301,
            column: 71
          },
          end: {
            line: 301,
            column: 72
          }
        }, {
          start: {
            line: 301,
            column: 75
          },
          end: {
            line: 301,
            column: 76
          }
        }],
        line: 301
      },
      "52": {
        loc: {
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 311,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 311,
            column: 7
          }
        }, {
          start: {
            line: 303,
            column: 6
          },
          end: {
            line: 311,
            column: 7
          }
        }],
        line: 303
      },
      "53": {
        loc: {
          start: {
            line: 303,
            column: 10
          },
          end: {
            line: 303,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 303,
            column: 10
          },
          end: {
            line: 303,
            column: 28
          }
        }, {
          start: {
            line: 303,
            column: 32
          },
          end: {
            line: 303,
            column: 62
          }
        }, {
          start: {
            line: 303,
            column: 66
          },
          end: {
            line: 303,
            column: 99
          }
        }],
        line: 303
      },
      "54": {
        loc: {
          start: {
            line: 305,
            column: 13
          },
          end: {
            line: 311,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 305,
            column: 13
          },
          end: {
            line: 311,
            column: 7
          }
        }, {
          start: {
            line: 305,
            column: 13
          },
          end: {
            line: 311,
            column: 7
          }
        }],
        line: 305
      },
      "55": {
        loc: {
          start: {
            line: 308,
            column: 23
          },
          end: {
            line: 308,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 308,
            column: 59
          },
          end: {
            line: 308,
            column: 71
          }
        }, {
          start: {
            line: 308,
            column: 74
          },
          end: {
            line: 308,
            column: 77
          }
        }],
        line: 308
      },
      "56": {
        loc: {
          start: {
            line: 310,
            column: 23
          },
          end: {
            line: 310,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 310,
            column: 54
          },
          end: {
            line: 310,
            column: 55
          }
        }, {
          start: {
            line: 310,
            column: 58
          },
          end: {
            line: 310,
            column: 59
          }
        }],
        line: 310
      },
      "57": {
        loc: {
          start: {
            line: 315,
            column: 6
          },
          end: {
            line: 316,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 315,
            column: 6
          },
          end: {
            line: 316,
            column: 52
          }
        }, {
          start: {
            line: 315,
            column: 6
          },
          end: {
            line: 316,
            column: 52
          }
        }],
        line: 315
      },
      "58": {
        loc: {
          start: {
            line: 316,
            column: 11
          },
          end: {
            line: 316,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 316,
            column: 11
          },
          end: {
            line: 316,
            column: 52
          }
        }, {
          start: {
            line: 316,
            column: 11
          },
          end: {
            line: 316,
            column: 52
          }
        }],
        line: 316
      },
      "59": {
        loc: {
          start: {
            line: 322,
            column: 67
          },
          end: {
            line: 322,
            column: 87
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 322,
            column: 85
          },
          end: {
            line: 322,
            column: 87
          }
        }],
        line: 322
      },
      "60": {
        loc: {
          start: {
            line: 326,
            column: 6
          },
          end: {
            line: 329,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 326,
            column: 6
          },
          end: {
            line: 329,
            column: 7
          }
        }, {
          start: {
            line: 326,
            column: 6
          },
          end: {
            line: 329,
            column: 7
          }
        }],
        line: 326
      },
      "61": {
        loc: {
          start: {
            line: 333,
            column: 6
          },
          end: {
            line: 335,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 333,
            column: 6
          },
          end: {
            line: 335,
            column: 7
          }
        }, {
          start: {
            line: 333,
            column: 6
          },
          end: {
            line: 335,
            column: 7
          }
        }],
        line: 333
      },
      "62": {
        loc: {
          start: {
            line: 333,
            column: 10
          },
          end: {
            line: 333,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 333,
            column: 10
          },
          end: {
            line: 333,
            column: 21
          }
        }, {
          start: {
            line: 333,
            column: 25
          },
          end: {
            line: 333,
            column: 60
          }
        }],
        line: 333
      },
      "63": {
        loc: {
          start: {
            line: 340,
            column: 6
          },
          end: {
            line: 348,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 340,
            column: 6
          },
          end: {
            line: 348,
            column: 7
          }
        }, {
          start: {
            line: 340,
            column: 6
          },
          end: {
            line: 348,
            column: 7
          }
        }],
        line: 340
      },
      "64": {
        loc: {
          start: {
            line: 345,
            column: 10
          },
          end: {
            line: 345,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 345,
            column: 46
          },
          end: {
            line: 345,
            column: 54
          }
        }, {
          start: {
            line: 345,
            column: 57
          },
          end: {
            line: 345,
            column: 67
          }
        }],
        line: 345
      },
      "65": {
        loc: {
          start: {
            line: 361,
            column: 29
          },
          end: {
            line: 361,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 361,
            column: 29
          },
          end: {
            line: 361,
            column: 39
          }
        }, {
          start: {
            line: 361,
            column: 43
          },
          end: {
            line: 361,
            column: 45
          }
        }],
        line: 361
      },
      "66": {
        loc: {
          start: {
            line: 369,
            column: 4
          },
          end: {
            line: 369,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 369,
            column: 4
          },
          end: {
            line: 369,
            column: 21
          }
        }, {
          start: {
            line: 369,
            column: 4
          },
          end: {
            line: 369,
            column: 21
          }
        }],
        line: 369
      },
      "67": {
        loc: {
          start: {
            line: 374,
            column: 4
          },
          end: {
            line: 374,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 374,
            column: 4
          },
          end: {
            line: 374,
            column: 45
          }
        }, {
          start: {
            line: 374,
            column: 4
          },
          end: {
            line: 374,
            column: 45
          }
        }],
        line: 374
      },
      "68": {
        loc: {
          start: {
            line: 378,
            column: 4
          },
          end: {
            line: 378,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 378,
            column: 4
          },
          end: {
            line: 378,
            column: 52
          }
        }, {
          start: {
            line: 378,
            column: 4
          },
          end: {
            line: 378,
            column: 52
          }
        }],
        line: 378
      },
      "69": {
        loc: {
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 380,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 380,
            column: 35
          }
        }, {
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 380,
            column: 35
          }
        }],
        line: 380
      },
      "70": {
        loc: {
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 385,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 385,
            column: 35
          }
        }, {
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 385,
            column: 35
          }
        }],
        line: 385
      },
      "71": {
        loc: {
          start: {
            line: 391,
            column: 4
          },
          end: {
            line: 391,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 391,
            column: 4
          },
          end: {
            line: 391,
            column: 22
          }
        }, {
          start: {
            line: 391,
            column: 4
          },
          end: {
            line: 391,
            column: 22
          }
        }],
        line: 391
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0, 0, 0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0],
      "68": [0, 0],
      "69": [0, 0],
      "70": [0, 0],
      "71": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { CHANGE_TOPIC } from './types';
var IS_NOT_MATCHED_VALUE = (cov_1uc4i0bxrm.s[0]++, 'IS_NOT_MATCHED_VALUE');
export var CheckedMode = (cov_1uc4i0bxrm.s[1]++, {
  // 只返回全选数据，包含父节点和子节点
  Full: 0,
  // 返回全部选择字节点和部分选中的父节点
  Half: 1,
  // 只返回选中子节点
  Child: 2,
  // 如果父节点下所有子节点全部选中，只返回父节点
  Shallow: 3,
  // 所选即所得
  Freedom: 4
});
cov_1uc4i0bxrm.s[2]++;

// check status stack
var checkStatusStack = function checkStatusStack(stack, defaultStatus) {
  cov_1uc4i0bxrm.f[0]++;
  cov_1uc4i0bxrm.s[3]++;

  if ((cov_1uc4i0bxrm.b[1][0]++, !stack) || (cov_1uc4i0bxrm.b[1][1]++, stack.length <= 0)) {
    cov_1uc4i0bxrm.b[0][0]++;
    cov_1uc4i0bxrm.s[4]++;
    return defaultStatus;
  } else {
    cov_1uc4i0bxrm.b[0][1]++;
  }

  cov_1uc4i0bxrm.s[5]++;

  if (stack.filter(function (d) {
    cov_1uc4i0bxrm.f[1]++;
    cov_1uc4i0bxrm.s[6]++;
    return d === 0;
  }).length === stack.length) {
    cov_1uc4i0bxrm.b[2][0]++;
    cov_1uc4i0bxrm.s[7]++;
    return 0;
  } else {
    cov_1uc4i0bxrm.b[2][1]++;
  }

  var s = (cov_1uc4i0bxrm.s[8]++, stack.filter(function (d) {
    cov_1uc4i0bxrm.f[2]++;
    cov_1uc4i0bxrm.s[9]++;
    return (cov_1uc4i0bxrm.b[3][0]++, d === 0) || (cov_1uc4i0bxrm.b[3][1]++, d === 2);
  }));
  cov_1uc4i0bxrm.s[10]++;

  if (s.length <= 0) {
    cov_1uc4i0bxrm.b[4][0]++;
    cov_1uc4i0bxrm.s[11]++;
    return defaultStatus;
  } else {
    cov_1uc4i0bxrm.b[4][1]++;
  }

  cov_1uc4i0bxrm.s[12]++;
  return 2;
};

var _default =
/*#__PURE__*/
function () {
  function _default() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1uc4i0bxrm.b[5][0]++, {
      data: [],
      childrenKey: ''
    });

    _classCallCheck(this, _default);

    this.keygen = void 0;
    this.mode = void 0;
    this.unmatch = void 0;
    this.disabled = void 0;
    this.childrenKey = void 0;
    this.valueMap = void 0;
    this.unmatchedValueMap = void 0;
    this.events = void 0;
    this.$events = void 0;
    this.value = void 0;
    this.data = void 0;
    this.cachedValue = void 0;
    this.pathMap = void 0;
    this.dataMap = void 0;
    cov_1uc4i0bxrm.f[3]++;

    var _ref = (cov_1uc4i0bxrm.s[13]++, options),
        data = _ref.data,
        value = _ref.value,
        keygen = _ref.keygen,
        mode = _ref.mode,
        disabled = _ref.disabled,
        _ref$childrenKey = _ref.childrenKey,
        childrenKey = _ref$childrenKey === void 0 ? (cov_1uc4i0bxrm.b[6][0]++, 'children') : _ref$childrenKey,
        unmatch = _ref.unmatch;

    cov_1uc4i0bxrm.s[14]++;
    this.keygen = keygen;
    cov_1uc4i0bxrm.s[15]++;
    this.mode = mode;
    cov_1uc4i0bxrm.s[16]++;
    this.valueMap = new Map();
    cov_1uc4i0bxrm.s[17]++;
    this.unmatchedValueMap = new Map();
    cov_1uc4i0bxrm.s[18]++;
    this.unmatch = unmatch;
    cov_1uc4i0bxrm.s[19]++;
    this.events = new Map();
    cov_1uc4i0bxrm.s[20]++;
    this.$events = {};
    cov_1uc4i0bxrm.s[21]++;
    this.childrenKey = childrenKey;
    cov_1uc4i0bxrm.s[22]++;
    this.updateDisabled(disabled);
    cov_1uc4i0bxrm.s[23]++;
    this.setValue(value);
    cov_1uc4i0bxrm.s[24]++;
    this.setData(data);
  }

  _createClass(_default, [{
    key: "updateDisabled",
    value: function updateDisabled(dis) {
      cov_1uc4i0bxrm.f[4]++;
      cov_1uc4i0bxrm.s[25]++;

      if (typeof dis === 'function') {
        cov_1uc4i0bxrm.b[7][0]++;
        cov_1uc4i0bxrm.s[26]++;
        this.disabled = dis;
      } else {
        cov_1uc4i0bxrm.b[7][1]++;
        cov_1uc4i0bxrm.s[27]++;

        this.disabled = function () {
          cov_1uc4i0bxrm.f[5]++;
          cov_1uc4i0bxrm.s[28]++;
          return false;
        };
      }
    }
  }, {
    key: "bind",
    value: function bind(id, update) {
      cov_1uc4i0bxrm.f[6]++;
      cov_1uc4i0bxrm.s[29]++;
      this.events.set(id, update);
    }
  }, {
    key: "unbind",
    value: function unbind(id) {
      cov_1uc4i0bxrm.f[7]++;
      cov_1uc4i0bxrm.s[30]++;
      this.events["delete"](id);
    }
  }, {
    key: "setUnmatedValue",
    value: function setUnmatedValue() {
      var _this = this;

      cov_1uc4i0bxrm.f[8]++;
      cov_1uc4i0bxrm.s[31]++;
      this.unmatchedValueMap = new Map();
      cov_1uc4i0bxrm.s[32]++;

      if ((cov_1uc4i0bxrm.b[9][0]++, !this.value) || (cov_1uc4i0bxrm.b[9][1]++, !this.data)) {
        cov_1uc4i0bxrm.b[8][0]++;
        cov_1uc4i0bxrm.s[33]++;
        return;
      } else {
        cov_1uc4i0bxrm.b[8][1]++;
      }

      cov_1uc4i0bxrm.s[34]++;
      this.value.forEach(function (v) {
        cov_1uc4i0bxrm.f[9]++;
        var data = (cov_1uc4i0bxrm.s[35]++, _this.getDataById(v));
        var unmatched = (cov_1uc4i0bxrm.s[36]++, _this.isUnMatch(data));
        cov_1uc4i0bxrm.s[37]++;

        if (unmatched) {
          cov_1uc4i0bxrm.b[10][0]++;
          cov_1uc4i0bxrm.s[38]++;

          _this.unmatchedValueMap.set(v, true);
        } else {
          cov_1uc4i0bxrm.b[10][1]++;
          cov_1uc4i0bxrm.s[39]++;

          _this.unmatchedValueMap["delete"](v);
        }
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "isUnMatch",
    value: function isUnMatch(data) {
      cov_1uc4i0bxrm.f[10]++;
      cov_1uc4i0bxrm.s[40]++;
      return (cov_1uc4i0bxrm.b[11][0]++, data) && (cov_1uc4i0bxrm.b[11][1]++, data[IS_NOT_MATCHED_VALUE]);
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      cov_1uc4i0bxrm.f[11]++;
      cov_1uc4i0bxrm.s[41]++;
      this.value = value;
      cov_1uc4i0bxrm.s[42]++;

      if ((cov_1uc4i0bxrm.b[13][0]++, value) && (cov_1uc4i0bxrm.b[13][1]++, value !== this.cachedValue)) {
        cov_1uc4i0bxrm.b[12][0]++;
        cov_1uc4i0bxrm.s[43]++;
        this.initValue();
      } else {
        cov_1uc4i0bxrm.b[12][1]++;
      }

      cov_1uc4i0bxrm.s[44]++;
      this.setUnmatedValue();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _this2 = this;

      cov_1uc4i0bxrm.f[12]++;
      var value = (cov_1uc4i0bxrm.s[45]++, []);
      cov_1uc4i0bxrm.s[46]++;
      this.valueMap.forEach(function (checked, id) {
        cov_1uc4i0bxrm.f[13]++;
        cov_1uc4i0bxrm.s[47]++;

        switch (_this2.mode) {
          case CheckedMode.Full:
            cov_1uc4i0bxrm.b[14][0]++;

          case CheckedMode.Freedom:
            cov_1uc4i0bxrm.b[14][1]++;
            cov_1uc4i0bxrm.s[48]++;

            if (checked === 1) {
              cov_1uc4i0bxrm.b[15][0]++;
              cov_1uc4i0bxrm.s[49]++;
              value.push(id);
            } else {
              cov_1uc4i0bxrm.b[15][1]++;
            }

            cov_1uc4i0bxrm.s[50]++;
            break;

          case CheckedMode.Half:
            cov_1uc4i0bxrm.b[14][2]++;
            cov_1uc4i0bxrm.s[51]++;

            if (checked >= 1) {
              cov_1uc4i0bxrm.b[16][0]++;
              cov_1uc4i0bxrm.s[52]++;
              value.push(id);
            } else {
              cov_1uc4i0bxrm.b[16][1]++;
            }

            cov_1uc4i0bxrm.s[53]++;
            break;

          case CheckedMode.Child:
            cov_1uc4i0bxrm.b[14][3]++;
            cov_1uc4i0bxrm.s[54]++;

            if (checked === 1) {
              cov_1uc4i0bxrm.b[17][0]++;
              var info = (cov_1uc4i0bxrm.s[55]++, _this2.pathMap.get(id));
              cov_1uc4i0bxrm.s[56]++;

              if ((cov_1uc4i0bxrm.b[19][0]++, info) && (cov_1uc4i0bxrm.b[19][1]++, info.children.length === 0)) {
                cov_1uc4i0bxrm.b[18][0]++;
                cov_1uc4i0bxrm.s[57]++;
                value.push(id);
              } else {
                cov_1uc4i0bxrm.b[18][1]++;
              }
            } else {
              cov_1uc4i0bxrm.b[17][1]++;
            }

            cov_1uc4i0bxrm.s[58]++;
            break;

          case CheckedMode.Shallow:
            cov_1uc4i0bxrm.b[14][4]++;
            cov_1uc4i0bxrm.s[59]++;

            if (checked === 1) {
              cov_1uc4i0bxrm.b[20][0]++;
              var parentChecked = (cov_1uc4i0bxrm.s[60]++, function () {
                cov_1uc4i0bxrm.f[14]++;
                var info = (cov_1uc4i0bxrm.s[61]++, _this2.pathMap.get(id));
                cov_1uc4i0bxrm.s[62]++;

                if (!info) {
                  cov_1uc4i0bxrm.b[21][0]++;
                  cov_1uc4i0bxrm.s[63]++;
                  return false;
                } else {
                  cov_1uc4i0bxrm.b[21][1]++;
                }

                var _ref2 = (cov_1uc4i0bxrm.s[64]++, info),
                    path = _ref2.path;

                var pid = (cov_1uc4i0bxrm.s[65]++, path[path.length - 1]);
                cov_1uc4i0bxrm.s[66]++;

                if ((cov_1uc4i0bxrm.b[23][0]++, !pid) && (cov_1uc4i0bxrm.b[23][1]++, pid !== 0)) {
                  cov_1uc4i0bxrm.b[22][0]++;
                  cov_1uc4i0bxrm.s[67]++;
                  return false;
                } else {
                  cov_1uc4i0bxrm.b[22][1]++;
                }

                cov_1uc4i0bxrm.s[68]++;
                return _this2.valueMap.get(pid) === 1;
              }());
              cov_1uc4i0bxrm.s[69]++;

              if (!parentChecked) {
                cov_1uc4i0bxrm.b[24][0]++;
                cov_1uc4i0bxrm.s[70]++;
                value.push(id);
              } else {
                cov_1uc4i0bxrm.b[24][1]++;
              }
            } else {
              cov_1uc4i0bxrm.b[20][1]++;
            }

            cov_1uc4i0bxrm.s[71]++;
            break;

          default:
            cov_1uc4i0bxrm.b[14][5]++;
        }
      });
      cov_1uc4i0bxrm.s[72]++;
      this.unmatchedValueMap.forEach(function (unmatch, id) {
        cov_1uc4i0bxrm.f[15]++;
        cov_1uc4i0bxrm.s[73]++;

        if ((cov_1uc4i0bxrm.b[26][0]++, unmatch) && (cov_1uc4i0bxrm.b[26][1]++, _this2.unmatch)) {
          cov_1uc4i0bxrm.b[25][0]++;
          cov_1uc4i0bxrm.s[74]++;
          value.push(id);
        } else {
          cov_1uc4i0bxrm.b[25][1]++;
        }
      });
      cov_1uc4i0bxrm.s[75]++;
      this.cachedValue = value;
      cov_1uc4i0bxrm.s[76]++;
      return value;
    }
  }, {
    key: "setValueMap",
    value: function setValueMap(id, checked) {
      cov_1uc4i0bxrm.f[16]++;
      cov_1uc4i0bxrm.s[77]++;
      this.valueMap.set(id, checked);
      var update = (cov_1uc4i0bxrm.s[78]++, this.events.get(id));
      cov_1uc4i0bxrm.s[79]++;

      if (update) {
        cov_1uc4i0bxrm.b[27][0]++;
        cov_1uc4i0bxrm.s[80]++;
        update();
      } else {
        cov_1uc4i0bxrm.b[27][1]++;
      }
    }
  }, {
    key: "set",
    value: function set(id, checked, direction) {
      var _this3 = this;

      cov_1uc4i0bxrm.f[17]++;
      cov_1uc4i0bxrm.s[81]++;

      // self
      if (!this.isDisabled(id)) {
        cov_1uc4i0bxrm.b[28][0]++;
        cov_1uc4i0bxrm.s[82]++;
        this.setValueMap(id, checked);
      } else {
        cov_1uc4i0bxrm.b[28][1]++;
      }

      var data = (cov_1uc4i0bxrm.s[83]++, this.getDataById(id));
      cov_1uc4i0bxrm.s[84]++;

      if ((cov_1uc4i0bxrm.b[30][0]++, data) && (cov_1uc4i0bxrm.b[30][1]++, data[IS_NOT_MATCHED_VALUE])) {
        cov_1uc4i0bxrm.b[29][0]++;
        cov_1uc4i0bxrm.s[85]++;

        if (checked) {
          cov_1uc4i0bxrm.b[31][0]++;
          cov_1uc4i0bxrm.s[86]++;
          this.unmatchedValueMap.set(id, true);
        } else {
          cov_1uc4i0bxrm.b[31][1]++;
          cov_1uc4i0bxrm.s[87]++;
          this.unmatchedValueMap["delete"](id);
        }

        cov_1uc4i0bxrm.s[88]++;
        return null;
      } else {
        cov_1uc4i0bxrm.b[29][1]++;
      }

      cov_1uc4i0bxrm.s[89]++;

      if (CheckedMode.Freedom === this.mode) {
        cov_1uc4i0bxrm.b[32][0]++;
        cov_1uc4i0bxrm.s[90]++;
        // Free mode will return zero
        return 0;
      } else {
        cov_1uc4i0bxrm.b[32][1]++;
      }

      var _ref3 = (cov_1uc4i0bxrm.s[91]++, this.pathMap.get(id)),
          path = _ref3.path,
          children = _ref3.children;

      var childrenStack = (cov_1uc4i0bxrm.s[92]++, []); // children

      cov_1uc4i0bxrm.s[93]++;

      if (direction !== 'asc') {
        cov_1uc4i0bxrm.b[33][0]++;
        cov_1uc4i0bxrm.s[94]++;
        children.forEach(function (cid) {
          cov_1uc4i0bxrm.f[18]++;
          cov_1uc4i0bxrm.s[95]++;
          // push status to stack
          childrenStack.push(_this3.set(cid, checked, 'desc'));
        });
      } else {
        cov_1uc4i0bxrm.b[33][1]++;
      } // Exclude disabled


      var current = (cov_1uc4i0bxrm.s[96]++, this.valueMap.get(id)); // check all children status

      var status = (cov_1uc4i0bxrm.s[97]++, checkStatusStack(childrenStack, current));
      cov_1uc4i0bxrm.s[98]++;

      if (status !== current) {
        cov_1uc4i0bxrm.b[34][0]++;
        cov_1uc4i0bxrm.s[99]++;
        this.setValueMap(id, status);
        cov_1uc4i0bxrm.s[100]++;
        current = status;
      } else {
        cov_1uc4i0bxrm.b[34][1]++;
      } // parent


      cov_1uc4i0bxrm.s[101]++;

      if ((cov_1uc4i0bxrm.b[36][0]++, direction !== 'desc') && (cov_1uc4i0bxrm.b[36][1]++, path.length > 0)) {
        cov_1uc4i0bxrm.b[35][0]++;
        var parentId = (cov_1uc4i0bxrm.s[102]++, path[path.length - 1]);
        var parentChecked = (cov_1uc4i0bxrm.s[103]++, current);
        cov_1uc4i0bxrm.s[104]++;
        this.pathMap.get(parentId).children.forEach(function (cid) {
          cov_1uc4i0bxrm.f[19]++;
          cov_1uc4i0bxrm.s[105]++;

          if (parentChecked !== _this3.valueMap.get(cid)) {
            cov_1uc4i0bxrm.b[37][0]++;
            cov_1uc4i0bxrm.s[106]++;
            parentChecked = 2;
          } else {
            cov_1uc4i0bxrm.b[37][1]++;
          }
        });
        cov_1uc4i0bxrm.s[107]++;
        this.set(parentId, parentChecked, 'asc');
      } else {
        cov_1uc4i0bxrm.b[35][1]++;
      }

      cov_1uc4i0bxrm.s[108]++;
      return current;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(id) {
      cov_1uc4i0bxrm.f[20]++;
      var node = (cov_1uc4i0bxrm.s[109]++, this.pathMap.get(id));
      cov_1uc4i0bxrm.s[110]++;

      if (node) {
        cov_1uc4i0bxrm.b[38][0]++;
        cov_1uc4i0bxrm.s[111]++;
        return node.isDisabled;
      } else {
        cov_1uc4i0bxrm.b[38][1]++;
      }

      cov_1uc4i0bxrm.s[112]++;
      return false;
    }
  }, {
    key: "get",
    value: function get(id) {
      cov_1uc4i0bxrm.f[21]++;
      cov_1uc4i0bxrm.s[113]++;
      return this.valueMap.get(id);
    }
  }, {
    key: "getDataById",
    value: function getDataById(id) {
      var _ref4;

      cov_1uc4i0bxrm.f[22]++;
      var oroginData = (cov_1uc4i0bxrm.s[114]++, this.dataMap.get(id));
      cov_1uc4i0bxrm.s[115]++;

      if (oroginData) {
        cov_1uc4i0bxrm.b[39][0]++;
        cov_1uc4i0bxrm.s[116]++;
        return oroginData;
      } else {
        cov_1uc4i0bxrm.b[39][1]++;
      }

      cov_1uc4i0bxrm.s[117]++;

      if (!this.unmatch) {
        cov_1uc4i0bxrm.b[40][0]++;
        cov_1uc4i0bxrm.s[118]++;
        return null;
      } else {
        cov_1uc4i0bxrm.b[40][1]++;
      }

      cov_1uc4i0bxrm.s[119]++;
      return _ref4 = {}, _defineProperty(_ref4, IS_NOT_MATCHED_VALUE, true), _defineProperty(_ref4, "value", id), _ref4;
    }
  }, {
    key: "getPath",
    value: function getPath(id) {
      cov_1uc4i0bxrm.f[23]++;
      cov_1uc4i0bxrm.s[120]++;
      return this.pathMap.get(id);
    }
  }, {
    key: "getChecked",
    value: function getChecked(id) {
      cov_1uc4i0bxrm.f[24]++;
      var value = (cov_1uc4i0bxrm.s[121]++, this.get(id));
      var checked = (cov_1uc4i0bxrm.s[122]++, value === 1);
      cov_1uc4i0bxrm.s[123]++;

      if (value === 2) {
        cov_1uc4i0bxrm.b[41][0]++;
        cov_1uc4i0bxrm.s[124]++;
        checked = 'indeterminate';
      } else {
        cov_1uc4i0bxrm.b[41][1]++;
      }

      cov_1uc4i0bxrm.s[125]++;
      return checked;
    }
  }, {
    key: "getKey",
    value: function getKey(data) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1uc4i0bxrm.b[42][0]++, '');
      var index = arguments.length > 2 ? arguments[2] : undefined;
      cov_1uc4i0bxrm.f[25]++;
      cov_1uc4i0bxrm.s[126]++;

      if (typeof this.keygen === 'function') {
        cov_1uc4i0bxrm.b[43][0]++;
        cov_1uc4i0bxrm.s[127]++;
        return this.keygen(data, id);
      } else {
        cov_1uc4i0bxrm.b[43][1]++;
      }

      cov_1uc4i0bxrm.s[128]++;

      if (this.keygen) {
        cov_1uc4i0bxrm.b[44][0]++;
        cov_1uc4i0bxrm.s[129]++;
        return data[this.keygen];
      } else {
        cov_1uc4i0bxrm.b[44][1]++;
      }

      cov_1uc4i0bxrm.s[130]++;
      return id + (id ? (cov_1uc4i0bxrm.b[45][0]++, ',') : (cov_1uc4i0bxrm.b[45][1]++, '')) + index;
    }
  }, {
    key: "initValue",
    value: function initValue(ids, forceCheck) {
      var _this4 = this;

      cov_1uc4i0bxrm.f[26]++;
      cov_1uc4i0bxrm.s[131]++;

      if ((cov_1uc4i0bxrm.b[47][0]++, !this.data) || (cov_1uc4i0bxrm.b[47][1]++, !this.value)) {
        cov_1uc4i0bxrm.b[46][0]++;
        cov_1uc4i0bxrm.s[132]++;
        return undefined;
      } else {
        cov_1uc4i0bxrm.b[46][1]++;
      }

      cov_1uc4i0bxrm.s[133]++;

      if (!ids) {
        cov_1uc4i0bxrm.b[48][0]++;
        cov_1uc4i0bxrm.s[134]++;
        ids = [];
        cov_1uc4i0bxrm.s[135]++;
        this.pathMap.forEach(function (val, id) {
          cov_1uc4i0bxrm.f[27]++;
          cov_1uc4i0bxrm.s[136]++;

          if (val.path.length === 0) {
            cov_1uc4i0bxrm.b[49][0]++;
            cov_1uc4i0bxrm.s[137]++;
            ids.push(id);
          } else {
            cov_1uc4i0bxrm.b[49][1]++;
          }
        });
      } else {
        cov_1uc4i0bxrm.b[48][1]++;
      }

      var checked;
      cov_1uc4i0bxrm.s[138]++;
      ids.forEach(function (id) {
        cov_1uc4i0bxrm.f[28]++;

        var _ref5 = (cov_1uc4i0bxrm.s[139]++, _this4.pathMap.get(id)),
            children = _ref5.children;

        cov_1uc4i0bxrm.s[140]++;

        if (forceCheck) {
          cov_1uc4i0bxrm.b[50][0]++;
          cov_1uc4i0bxrm.s[141]++;

          _this4.setValueMap(id, 1);

          cov_1uc4i0bxrm.s[142]++;

          _this4.initValue(children, forceCheck);

          cov_1uc4i0bxrm.s[143]++;
          return;
        } else {
          cov_1uc4i0bxrm.b[50][1]++;
        }

        var childChecked = (cov_1uc4i0bxrm.s[144]++, _this4.value.indexOf(id) >= 0 ? (cov_1uc4i0bxrm.b[51][0]++, 1) : (cov_1uc4i0bxrm.b[51][1]++, 0));
        cov_1uc4i0bxrm.s[145]++;

        if ((cov_1uc4i0bxrm.b[53][0]++, childChecked === 1) && (cov_1uc4i0bxrm.b[53][1]++, _this4.mode !== CheckedMode.Half) && (cov_1uc4i0bxrm.b[53][2]++, _this4.mode !== CheckedMode.Freedom)) {
          cov_1uc4i0bxrm.b[52][0]++;
          cov_1uc4i0bxrm.s[146]++;

          _this4.initValue(children, true);
        } else {
          cov_1uc4i0bxrm.b[52][1]++;
          cov_1uc4i0bxrm.s[147]++;

          if (children.length > 0) {
            cov_1uc4i0bxrm.b[54][0]++;
            // 保持迭代
            var res = (cov_1uc4i0bxrm.s[148]++, _this4.initValue(children));
            cov_1uc4i0bxrm.s[149]++;
            childChecked = _this4.mode === CheckedMode.Freedom ? (cov_1uc4i0bxrm.b[55][0]++, childChecked) : (cov_1uc4i0bxrm.b[55][1]++, res);
          } else {
            cov_1uc4i0bxrm.b[54][1]++;
            cov_1uc4i0bxrm.s[150]++;
            childChecked = _this4.value.indexOf(id) >= 0 ? (cov_1uc4i0bxrm.b[56][0]++, 1) : (cov_1uc4i0bxrm.b[56][1]++, 0);
          }
        }

        cov_1uc4i0bxrm.s[151]++;

        _this4.setValueMap(id, childChecked);

        cov_1uc4i0bxrm.s[152]++;

        if (checked === undefined) {
          cov_1uc4i0bxrm.b[57][0]++;
          cov_1uc4i0bxrm.s[153]++;
          checked = childChecked;
        } else {
          cov_1uc4i0bxrm.b[57][1]++;
          cov_1uc4i0bxrm.s[154]++;

          if (checked !== childChecked) {
            cov_1uc4i0bxrm.b[58][0]++;
            cov_1uc4i0bxrm.s[155]++;
            checked = 2;
          } else {
            cov_1uc4i0bxrm.b[58][1]++;
          }
        }
      });
      cov_1uc4i0bxrm.s[156]++;
      return checked;
    }
  }, {
    key: "initData",
    value: function initData(data, path, disabled) {
      var _this5 = this;

      var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (cov_1uc4i0bxrm.b[59][0]++, []);
      cov_1uc4i0bxrm.f[29]++;
      var ids = (cov_1uc4i0bxrm.s[157]++, []);
      cov_1uc4i0bxrm.s[158]++;
      data.forEach(function (d, i) {
        cov_1uc4i0bxrm.f[30]++;
        var id = (cov_1uc4i0bxrm.s[159]++, _this5.getKey(d, path[path.length - 1], i));
        cov_1uc4i0bxrm.s[160]++;

        if (_this5.dataMap.get(id)) {
          cov_1uc4i0bxrm.b[60][0]++;
          cov_1uc4i0bxrm.s[161]++;
          console.error("There is already a key \"".concat(id, "\" exists. The key must be unique."));
          cov_1uc4i0bxrm.s[162]++;
          return;
        } else {
          cov_1uc4i0bxrm.b[60][1]++;
        }

        cov_1uc4i0bxrm.s[163]++;

        _this5.dataMap.set(id, d);

        var isDisabled = (cov_1uc4i0bxrm.s[164]++, !!disabled);
        cov_1uc4i0bxrm.s[165]++;

        if ((cov_1uc4i0bxrm.b[62][0]++, !isDisabled) && (cov_1uc4i0bxrm.b[62][1]++, typeof _this5.disabled === 'function')) {
          cov_1uc4i0bxrm.b[61][0]++;
          cov_1uc4i0bxrm.s[166]++;
          isDisabled = _this5.disabled(d, i);
        } else {
          cov_1uc4i0bxrm.b[61][1]++;
        }

        var indexPath = (cov_1uc4i0bxrm.s[167]++, [].concat(_toConsumableArray(index), [i]));
        cov_1uc4i0bxrm.s[168]++;
        ids.push(id);
        var children = (cov_1uc4i0bxrm.s[169]++, []);
        cov_1uc4i0bxrm.s[170]++;

        if (Array.isArray(d[_this5.childrenKey])) {
          cov_1uc4i0bxrm.b[63][0]++;
          cov_1uc4i0bxrm.s[171]++;
          children = _this5.initData(d[_this5.childrenKey], [].concat(_toConsumableArray(path), [id]), // exclude Freedom
          _this5.mode === CheckedMode.Freedom ? (cov_1uc4i0bxrm.b[64][0]++, disabled) : (cov_1uc4i0bxrm.b[64][1]++, isDisabled), indexPath);
        } else {
          cov_1uc4i0bxrm.b[63][1]++;
        }

        cov_1uc4i0bxrm.s[172]++;

        _this5.pathMap.set(id, {
          children: children,
          path: path,
          isDisabled: isDisabled,
          indexPath: indexPath,
          index: i
        });
      });
      cov_1uc4i0bxrm.s[173]++;
      return ids;
    }
  }, {
    key: "setData",
    value: function setData(data, dispatch) {
      cov_1uc4i0bxrm.f[31]++;
      var prevValue = (cov_1uc4i0bxrm.s[174]++, (cov_1uc4i0bxrm.b[65][0]++, this.value) || (cov_1uc4i0bxrm.b[65][1]++, []));
      cov_1uc4i0bxrm.s[175]++;
      this.cachedValue = [];
      cov_1uc4i0bxrm.s[176]++;
      this.pathMap = new Map();
      cov_1uc4i0bxrm.s[177]++;
      this.dataMap = new Map();
      cov_1uc4i0bxrm.s[178]++;
      this.valueMap = new Map();
      cov_1uc4i0bxrm.s[179]++;
      this.unmatchedValueMap = new Map();
      cov_1uc4i0bxrm.s[180]++;
      this.data = data;
      cov_1uc4i0bxrm.s[181]++;

      if (!data) {
        cov_1uc4i0bxrm.b[66][0]++;
        cov_1uc4i0bxrm.s[182]++;
        return;
      } else {
        cov_1uc4i0bxrm.b[66][1]++;
      }

      cov_1uc4i0bxrm.s[183]++;
      this.initData(data, []);
      cov_1uc4i0bxrm.s[184]++;
      this.initValue();
      cov_1uc4i0bxrm.s[185]++;
      this.setValue(prevValue);
      cov_1uc4i0bxrm.s[186]++;

      if (dispatch) {
        cov_1uc4i0bxrm.b[67][0]++;
        cov_1uc4i0bxrm.s[187]++;
        this.dispatch(CHANGE_TOPIC);
      } else {
        cov_1uc4i0bxrm.b[67][1]++;
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(name, fn) {
      cov_1uc4i0bxrm.f[32]++;
      cov_1uc4i0bxrm.s[188]++;

      if (!this.$events[name]) {
        cov_1uc4i0bxrm.b[68][0]++;
        cov_1uc4i0bxrm.s[189]++;
        this.$events[name] = [];
      } else {
        cov_1uc4i0bxrm.b[68][1]++;
      }

      var events = (cov_1uc4i0bxrm.s[190]++, this.$events[name]);
      cov_1uc4i0bxrm.s[191]++;

      if (events.includes(fn)) {
        cov_1uc4i0bxrm.b[69][0]++;
        cov_1uc4i0bxrm.s[192]++;
        return;
      } else {
        cov_1uc4i0bxrm.b[69][1]++;
      }

      cov_1uc4i0bxrm.s[193]++;
      events.push(fn);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(name, fn) {
      cov_1uc4i0bxrm.f[33]++;
      cov_1uc4i0bxrm.s[194]++;

      if (!this.$events[name]) {
        cov_1uc4i0bxrm.b[70][0]++;
        cov_1uc4i0bxrm.s[195]++;
        return;
      } else {
        cov_1uc4i0bxrm.b[70][1]++;
      }

      cov_1uc4i0bxrm.s[196]++;
      this.$events[name] = this.$events[name].filter(function (e) {
        cov_1uc4i0bxrm.f[34]++;
        cov_1uc4i0bxrm.s[197]++;
        return e !== fn;
      });
    }
  }, {
    key: "dispatch",
    value: function dispatch(name) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      cov_1uc4i0bxrm.f[35]++;
      var event = (cov_1uc4i0bxrm.s[198]++, this.$events[name]);
      cov_1uc4i0bxrm.s[199]++;

      if (!event) {
        cov_1uc4i0bxrm.b[71][0]++;
        cov_1uc4i0bxrm.s[200]++;
        return;
      } else {
        cov_1uc4i0bxrm.b[71][1]++;
      }

      cov_1uc4i0bxrm.s[201]++;
      event.forEach(function (fn) {
        cov_1uc4i0bxrm.f[36]++;
        cov_1uc4i0bxrm.s[202]++;
        return fn.apply(void 0, args);
      });
    }
  }]);

  return _default;
}();

export { _default as default };